import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import React, { useEffect } from 'react';
import useStore from '../../store';
import LiliNotification, { LiliNotificationType } from '../../DesignSystem/LiliNotification/LiliNotification';
import { LiliToastDefaultConfig } from '../../DesignSystem/LiliToast/LiliToast';
import { UserMessage } from '../../DesignSystem/LiliUserMessage/UserMessage';
import { UpdateInvalidBusinessAddressForm } from './UpdateInvalidBusinessAddressForm';
import { trackMixPanel } from '../../services/mixpanel.service';

export interface UpdateInvalidBusinessAddressProps {
  onAddressUpdated: () => void;
}

export const RenderUpdateInvalidBusinessAddressModal = () => {
  const { t } = useTranslation();
  const { resetUserMessageSlice } = useStore(state => state);

  useEffect(() => {
    trackMixPanel('Change RA address modal showed');
  }, []);

  return (
    <UserMessage id='update-invalid-business-address' shouldPersist onClick={() => {}}>
      <UpdateInvalidBusinessAddressForm onAddressUpdated={() => {
        resetUserMessageSlice();
        toast(
          <LiliNotification
            type={LiliNotificationType.SUCCESS}
            title={t('UPDATE_BUSINESS_ADDRESS.SUCCESS_MODAL_TITLE')}
            text={t('UPDATE_BUSINESS_ADDRESS.SUCCESS_MODAL_DESCRIPTION')}
            id='update-business-address-success-notification'
          />,
          {
            ...LiliToastDefaultConfig,
            position: toast.POSITION.BOTTOM_CENTER,
            closeOnClick: false,
            autoClose: false,
          },
        );
      }}
      />
    </UserMessage>);
};
